<template>
  <div class="form-wrapper">
    <el-form :model="ruleform" class="popup" :rules="rules" ref="ruleform">
      <!-- <zj-layout-container class="header">
        <zj-layout-header>
          <div class="listtitle">
            景区监控
            <button
              type="button"
              aria-label="Close"
              class="el-dialog-close-btn"
              @click="onBack"
            >
              <i class="el-dialog__close el-icon el-icon-close"></i>
            </button>
          </div>
        </zj-layout-header>
      </zj-layout-container>-->
      <zj-layout-container class="content monitor-box">
        <div class="leftNav">
          <div class="leftNav_title">LED屏列表</div>
          <el-input placeholder="搜索LED屏" class="nav-tree-filter" v-model="filterText"></el-input>
          <div class="nav-tree-content">
            <el-tree
              style="height:100%;"
              v-loading="loading"
              :element-loading-text="loadingText"
              @node-click="nodeClick"
              :data="nodes"
              node-key="ID"
              :props="defaultProps"
              :filter-node-method="filterNode"
              class="zj-demo-player-tree-device-tree"
              ref="tree"
            ></el-tree>
          </div>
        </div>
        <!--  -->
        <div class="middleContent">
          <div class="leftNav_title">可用版式列表</div>
          <ul class="layOutLine">
            <li class="bantitle">版式名称：</li>
            <li
              class="layOne"
              :class="{ checkedLi: item.isChecked }"
              v-for="(item, index) in ledAllLayout"
              @click="changeItemStatus(item.isChecked, 'ledAllLayout', index)"
              :key="index"
            >{{ item.Name }}</li>
          </ul>
        </div>
        <div class="trangleBox">
          <div :class="{ okClick: isRight }" class="toptrangle" @click="toRightMove()">
            <i class="el-icon-d-arrow-right"></i>
          </div>
          <div :class="{ okClick: isLeft }" class="toptrangle" @click="toLeftMove()">
            <i class="el-icon-d-arrow-left"></i>
          </div>
        </div>
        <div class="rightContent">
          <div class="leftNav_title">已选择版式列表</div>
          <ul class="layOutLine" style="padding-right:20px;">
            <li class="bantitle" style="display:flex;justify-content:space-between;">
              <span>版式名称：</span>
              <span>显示时长(秒)</span>
            </li>
            <li
              :class="{ checkedLi: item.isChecked }"
              class="layOne innerNum"
              v-for="(item, index) in ledCheckedLayout"
              :key="index"
              @click="
                changeItemStatus(item.isChecked, 'ledCheckedLayout', index)
              "
            >
              <span>{{ item.Name }}</span>
              <el-input-number
                size="mini"
                v-model="item.Interval"
                controls-position="right"
                @change="handleChange"
                :min="0"
              ></el-input-number>
            </li>
          </ul>
        </div>
        <el-button type="primary" class="upScreen" @click="saveShangPing">上屏</el-button>
      </zj-layout-container>
    </el-form>
  </div>
</template>
<script>
import ZJApp from "../../../../../app";
// eslint-disable-next-line no-unused-vars
import MyApis from "../../../apis";
// eslint-disable-next-line no-unused-vars
import $ from "jquery";
export default {
  name: "LEDPlanManagerView",
  controller: "UI",
  action: "LEDPlanManagerView",
  data() {
    return {
      num: 1,
      filterText: "",
      loading: false,
      loadingText: "",
      nodes: [],
      regions: [],
      ledAllLayout: [], //显示可用版式列表
      letAllLayoutData: "", //储存可用版式值
      ledCheckedLayout: [],
      ledCheckedShowLayout: [],
      isRight: false,
      isLeft: false,
      screenId: "",
    };
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
  created() {
    this.getRegions();
  },
  mounted() {
    this.getLedLayout();
    this.logInfo.ActionName = "LED上屏查询";
    this.logInfo.LogMessage = "LED上屏查询";
    this.logInfo.ModuleName = "LED系统";
    this.logInfo.PageName = "LED上屏";
    this.addOperationLog();
  },
  methods: {
    // 弹出一个错误消息
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox",
      });
    },
    getRegions() {
      let that = this;
      new MyApis.RegionList()
        .GetRegionInfos({
          EquipmentType: "Monitor",
          Longitude: 0.0,
          Latitude: 0.0,
        })
        .then((r) => {
          //   console.log("区域")
          //   console.log(r)
          that.search();
          let data = r.data.Data;
          data.forEach((item) => {
            let obj = {
              ID: item.RegionId,
              label: item.RegionName,
              RegionNo: item.RegionNo,
              children: [],
            };
            that.regions.push(obj);
          });
        })
        .catch((e) => {
          //   console.error(e);
          that.$message({
            message: e.RspMsg ? e.RspMsg : "获取区域失败！",
            type: "error",
          });
        });
    },
    search() {
      let that = this;
      new MyApis.TranResourcesApi()
        .GetLedEquipmentList({})
        .then((r) => {
          r = r.data.Data;
          this.nodes = that.convertToTreeNodesfunction(r);
        })
        .catch((e) => {
          that.$message({
            message: e.RspMsg ? e.RspMsg : "搜索视频失败！",
            type: "error",
          });
        });
    },
    convertToTreeNodesfunction(list) {
      let result = this.regions;
      for (let i = 0; i < list.length; i++) {
        var regionData = list[i];
        // console.log("regionData")
        // console.log(regionData)
        var region = {
          ID: regionData.ID,
          label: regionData.NAME_EQT,
          children: [],
        };
        for (let j = 0; j < result.length; j++) {
          // console.log("result[j].RegionNo")
          // console.log(result[j].RegionNo)
          if (result[j].RegionNo == regionData.ARENUM_EQT) {
            console.log(regionData.ARENUM_EQ);
            result[j].children.push(region);
          }
        }
      }
      return result;
    },
    getLedLayout() {
      let that = this;
      new MyApis.LedgetApi()
        .GetLedLayoutList({})
        .then((r) => {
          r = r.data.Data;
          console.log("版式");
          console.log(r);
          if (r.length > 0) {
            r.forEach((item) => {
              item.isChecked = false;
              item.Interval = 0;
            });
            that.ledAllLayout = r;
            that.letAllLayoutData = JSON.stringify(r);
          }
        })
        .catch((e) => {
          that.$message({
            message: e.RspMsg ? e.RspMsg : "搜索视频失败！",
            type: "error",
          });
        });
    },
    getCheckedLedLayout(id) {
      let that = this;
      new MyApis.TranResourcesApi()
        .FindLedPlan({
          id: id,
        })
        .then((r) => {
          r = r.data.Data;
          console.log("已选择的版式");
          console.log(r);
          if (r.length == 0) {
            that.ledCheckedShowLayout = r;
            that.getCheckedLayout();
          } else {
            r.forEach((item) => {
              item.isChecked = false;
            });
            that.ledCheckedShowLayout = r;
            that.getCheckedLayout();
          }
        })
        .catch((e) => {
          that.$message({
            message: e.RspMsg ? e.RspMsg : "搜索视频失败！",
            type: "error",
          });
        });
    },
    getCheckedLayout() {
      let data = "";
      if (this.ledCheckedShowLayout.length > 0) {
        data = this.ledCheckedShowLayout[0].ItemList;
      } else {
        data = [];
      }
      let dataAll = this.ledAllLayout;
      if (data.length > 0) {
        let arr = [];
        data.forEach((item) => {
          for (let i = 0; i < dataAll.length; i++) {
            if (item.LayoutID == dataAll[i].ID) {
              dataAll[i].Interval = item.Interval;
              let obj = dataAll.splice(i, 1);
              arr = [...obj, ...arr];
              break;
            }
          }
        });
        this.ledCheckedLayout = arr;
      } else {
        this.ledCheckedLayout = [];
        this.ledAllLayout = JSON.parse(this.letAllLayoutData);
      }

      // console.log("this.ledAllLayout");
      // console.log(this.ledAllLayout);
      // console.log(this.letAllLayoutData);
    },
    changeItemStatus(status, type, index) {
      // console.log(status)
      // console.log(type)
      // console.log(index)
      // isRight:false,
      //  isLeft:false,
      if (type == "ledAllLayout") {
        this.ledAllLayout[index].isChecked = !status;
        for (let i = 0; i < this.ledAllLayout.length; i++) {
          if (this.ledAllLayout[i].isChecked) {
            this.isRight = true;
            break;
          } else {
            this.isRight = false;
          }
        }
      } else if (type == "ledCheckedLayout") {
        this.ledCheckedLayout[index].isChecked = !status;
        for (let i = 0; i < this.ledCheckedLayout.length; i++) {
          if (this.ledCheckedLayout[i].isChecked) {
            this.isLeft = true;
            break;
          } else {
            this.isLeft = false;
          }
        }
      }
    },
    // eslint-disable-next-line no-unused-vars
    nodeClick: function (data, node, self) {
      if (node.level == 2) {
        this.getCheckedLedLayout(data.ID);
        this.screenId = data.ID;
        if (this.letAllLayoutData) {
          this.ledAllLayout = JSON.parse(this.letAllLayoutData);
        }
      } else {
        this.screenId = "";
      }
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    toLeftMove() {
      if (this.screenId == "") {
        this.errmsg("请选择LED屏");
        return;
      }
      if (this.isLeft === false) {
        this.errmsg("请选择至少一个版式");
        return;
      }

      let data = this.ledCheckedLayout;
      console.log("data");
      console.log(data);
      let arrChecked = [];
      let arrNoChecked = [];
      for (let i = 0; i < data.length; i++) {
        if (data[i].isChecked) {
          arrChecked.push(data[i]);
        } else {
          arrNoChecked.push(data[i]);
        }
      }
      this.ledAllLayout = [...this.ledAllLayout, ...arrChecked];
      this.ledCheckedLayout = arrNoChecked;
    },
    toRightMove() {
      if (this.screenId == "") {
        this.errmsg("请选择LED屏");
        return;
      }
      if (this.isRight === false) {
        this.errmsg("请选择至少一个版式");
        return;
      }
      let data = this.ledAllLayout;
      console.log("data");
      console.log(data);
      let arrChecked = [];
      let arrNoChecked = [];
      for (let i = 0; i < data.length; i++) {
        if (data[i].isChecked) {
          arrChecked.push(data[i]);
        } else {
          arrNoChecked.push(data[i]);
        }
      }
      this.ledAllLayout = arrNoChecked;
      this.ledCheckedLayout = [...this.ledCheckedLayout, ...arrChecked];
    },
    saveShangPing() {
      let that = this;
      if (this.screenId == "") {
        this.errmsg("请选择LED屏");
        return;
      }
      if (this.ledCheckedLayout.length == 0) {
        this.errmsg("请选择LED屏的可用版式");
        return;
      }
      let data = this.ledCheckedLayout;
      let ItemList = [];
      data.forEach((item) => {
        let obj = {
          ID: "",
          PlanID: "",
          ScreenID: this.screenId,
          LayoutID: item.ID,
          Interval: item.Interval,
          Seq: 2,
          CreateTime: new Date(),
          Creater: ZJApp.ZJUser.current.UserName,
          ModifiyTime: new Date(),
          Modifier: ZJApp.ZJUser.current.UserName,
          Validity: 1,
          Extends1: "",
          Extends2: "",
          Extends3: 0.0,
        };
        ItemList.push(obj);
      });
      new MyApis.TranResourcesApi()
        .SendLedUpMessage({
          ID: "",
          ScreenID: this.screenId,
          Flags: "current",
          CreateTime: new Date(),
          Creater: ZJApp.ZJUser.current.UserName,
          ModifiyTime: new Date(),
          Modifier: ZJApp.ZJUser.current.UserName,
          Validity: 1,
          Extends1: "",
          Extends2: "",
          Extends3: 0.0,
          ItemList: ItemList,
        })
        .then((r) => {
          r = r.data.Data;
          console.log("上屏结果");
          console.log(r);
          if (r) {
            that.$message({
              message: "上屏成功",
              type: "success",
            });

            that.logInfo.ActionName = "LED上屏";
            that.logInfo.LogMessage = "LED上屏成功";
            that.logInfo.ModuleName = "LED系统";
            that.logInfo.PageName = "LED上屏";
            that.logInfo.CurrentValue = JSON.stringify(ItemList);
            that.addOperationLog();
          }
        })
        .catch((e) => {
          that.$message({
            message: e.RspMsg ? e.RspMsg : "搜索视频失败！",
            type: "error",
          });
        });
    },
  },
};
</script>
<style scoped>
.monitor-box {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-direction: row;
  padding: 20px 20px;
}
.leftNav {
  position: relative;
  padding-top: 20px;
  width: 30%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  overflow: auto;
}
.leftNav_title {
  font-size: 16px;
  border-bottom: 1px dashed #0ec0fe;
  color: #00bcfe;
  height: 40px;
  position: relative;
}
.nav-tree-filter {
  border-radius: 6px;
  border: solid 1px #00bcfe;
  margin-top: 45px;
  margin-bottom: 20px;
}
/* 中间 */
.middleContent {
  width: 30%;
  padding-top: 20px;
}
.rightContent {
  width: 30%;
  padding-top: 20px;
}
.layOutLine {
  width: 100%;
  padding: 20px 0px;
  background: rgba(12, 58, 122, 0.3);
  height: 500px;
}
.layOutLine li {
  list-style: none;
  font-size: 14px;
  line-height: 30px;
  height: 30px;
  padding-left: 20px;
  cursor: pointer;
  color: #9ab9ca;
  margin-bottom: 10px;
}
.bantitle {
  color: #fff;
  font-size: 16px;
  font-weight: bold;
}
.trangleBox {
  width: 30px;
  padding-left: 1px;
  padding-top: 200px;
}
.trangleBox div {
  width: 26px;
  height: 26px;
  text-align: center;
  line-height: 24px;
}
.toptrangle {
  border: 1px solid #0ec0fe;
  margin-bottom: 15px;
  color: #0ec0fe;
}
.innerNum {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.upScreen {
  position: absolute;
  right: 20px;
  bottom: 20px;
  font-size: 16px;
}
.checkedLi {
  background: rgba(12, 58, 122, 0.8);
}
.okClick {
  background: #298beb;
  color: #fff;
}
</style>
